import React from 'react';
import { Row, Col } from 'react-bootstrap';

const ChargesRow = ({ status = null }) => {
  return (
    <Row className="g-0 mb-2 d-none d-xl-flex">
      <Col>
        <Row className="g-0 h-100 align-content-center custom-sort ps-5 pe-4 h-100">
          <Col lg="2" className="d-flex flex-column mb-lg-0 pe-3">
            <div className="text-muted text-small cursor-pointer">ID USUARIO</div>
          </Col>
          <Col lg="3" className="d-flex flex-column mb-lg-0 pe-3">
            <div className="text-muted text-small cursor-pointer">CONCEPTO / ID ENVÍO </div>
          </Col>
          <Col lg="2" className="d-flex flex-column pe-1 justify-content-center align-items-center">
            <div className="text-muted text-small cursor-pointer">{`FECHA ${status === 'completed' ? 'CARGO' : 'INTENTO'}`}</div>
          </Col>
          <Col lg="2" className="d-flex flex-column pe-1 justify-content-center align-items-end">
            <div className="text-muted text-small cursor-pointer">REFERENCIA</div>
          </Col>
          <Col lg="1" className="d-flex flex-column pe-1 justify-content-center align-items-end">
            <div className="text-muted text-small cursor-pointer">CARGO</div>
          </Col>

          <Col lg="2" className="d-flex flex-column pe-1 mb-2 mb-lg-0 align-items-end order-2 order-lg-last justify-content-center">
            <div className="text-muted text-small cursor-pointer">AUTOR</div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ChargesRow;
